<!-- EXT-6537: Account # · Caller · GO, labels stacked above plain inputs, per
     the dashboard design. EXT-6573: it sits at the right end of the account
     bar. The GO button is the form's submit button, so Enter in Account # runs
     it too. -->
@if (displayAccountSetter()) {
  <form class="lookup" [formGroup]="form" (ngSubmit)="onSubmit()">
    <label class="lookup-field account-field">
      <span class="lookup-label" [class.invalid]="dealerIdInvalid()"
        >Account #</span
      >
      <span class="lookup-input-wrap">
        <input
          class="lookup-input account-input"
          [class.invalid]="dealerIdInvalid()"
          formControlName="dealerId"
          [matAutocomplete]="accountAuto"
          autocomplete="off"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="characters"
          aria-label="Account to set for portal"
          [attr.aria-invalid]="dealerIdInvalid()"
        />
        @if (dealerIdInvalid()) {
          <mat-icon
            class="error-icon"
            [matTooltip]="dealerIdErrorMessage()"
            matTooltipPosition="below"
            matTooltipClass="account-error-tooltip"
            [attr.aria-label]="dealerIdErrorMessage()"
            >error</mat-icon
          >
        }
      </span>
      <mat-autocomplete
        #accountAuto="matAutocomplete"
        class="account-search-panel"
        panelWidth="320px"
        (optionSelected)="onSuggestionSelected($event.option.value)"
      >
        @for (result of suggestions(); track result.accountNumber) {
          <mat-option
            [value]="result.accountNumber"
            [class.account-search-option--inactivating]="result.status === 'I'"
            [matTooltip]="
              result.status === 'I' ? 'Inactive — pending deletion' : ''
            "
            [matTooltipDisabled]="result.status !== 'I'"
            matTooltipPosition="right"
          >
            <strong
              >{{ result.accountNumber }} | {{ result.accountName }}</strong
            >
            <div class="account-search-detail">
              {{ result.city }}, {{ result.state }} {{ result.zip }}
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </label>

    <label class="lookup-field caller-field">
      <span class="lookup-label">Caller</span>
      <input
        class="lookup-input caller-input"
        formControlName="callerName"
        maxlength="10"
        spellcheck="false"
        autocorrect="off"
        aria-label="Name for caller"
      />
    </label>

    <button class="go-button" type="submit" [disabled]="loading()">
      @if (loading()) {
        <spinner [size]="'10px'" [thickness]="'3px'"></spinner>
      } @else {
        Go
      }
    </button>
  </form>
}
